import { Component } from "react";
import LayoutPublico from "../../componentes/Comunes/Layout/LayoutPublico";

class PaginaNoEncontrada extends Component {
  state = {};
  render() {
    return (
      <LayoutPublico>
        <div className="error mx-auto text-nowrap" data-text="404">
          404
        </div>
        <p className="lead text-gray-800 mb-4">Página no encontrada.</p>
        <button
          className="btn btn-primary btn-icon-split text-center"
          onClick={this.props.history.goBack}
        >
          <span className="icon text-white-50">
            <i className="fas fa-arrow-alt-circle-left"></i>
          </span>
          <span className="text">Regresar</span>
        </button>
      </LayoutPublico>
    );
  }
}

export default PaginaNoEncontrada;
